import * as DB from 'interfaces/database';
import {
	Vue, Component, Prop, toNative,
} from 'vue-facing-decorator';
import Template from './template.vue';

@Component({
	mixins: [Template],
})
class ColoredBox extends Vue {
	@Prop({
		type: Object,
		required: true,
	})
	public readonly data!: DB.PageBackgroundModel;
}

export default toNative(ColoredBox);
